import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

const InFulfillmentModal = ({ isOpen = false, onConfirm, onCancel }) => {
	const modalRef = useRef();
	const [confirmed, setConfirmed] = useState(false);

	useEffect(() => {
		if (isOpen) {
			setConfirmed(false);
			modalRef.current.showModal();
		}
	}, [isOpen]);

	return (
		<dialog id="in-fulfillment-dialog" className="modal" ref={modalRef}>
			<div className="modal-box">
				<h3 className="text-lg font-bold">Move to In Fulfillment?</h3>
				<div className="py-4">
					Please confirm that all SKUs have been added to this service request
					before moving it to In Fulfillment.
				</div>
				<div className="form-control">
					<label className="justify-start gap-2 cursor-pointer label">
						<input
							type="checkbox"
							className="checkbox checkbox-primary"
							checked={confirmed}
							onChange={(e) => setConfirmed(e.target.checked)}
						/>
						<span className="label-text">
							I confirm that all applicable SKUs have been added.
						</span>
					</label>
				</div>
				<div className="modal-action">
					<form method="dialog">
						<button className="btn" onClick={onCancel}>
							Cancel
						</button>
						<button
							className="ml-4 btn btn-primary"
							onClick={onConfirm}
							disabled={!confirmed}
						>
							Continue
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

InFulfillmentModal.propTypes = {
	isOpen: PropTypes.bool,
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default InFulfillmentModal;
